<div class='text-center meta-link mt-3' *ngIf="currentConfig.reportId !== 'sellerTrustIndex'">
  <h6>Read about our Publisher Trust Index Methodology</h6>
  <a class="btn btn-primary methodology-link text-light"
    href="https://info.pixalate.com/publisher-trust-index-methodology" target="_blank">Click here</a>
</div>
<div class='text-center meta-link mt-3' *ngIf="currentConfig.reportId === 'sellerTrustIndex'">
  <h6>Read about our Seller Trust Index Methodology</h6>
  <a class="btn btn-primary methodology-link text-light" href="https://www.pixalate.com/knowledgebase/rankings"
    target="_blank">Click here</a>
</div>
<div class='text-center meta-link mt-3'>
  <h6>Want to Improve Your Publisher Score?</h6>
  <a class="btn btn-primary methodology-link text-light"
    href="https://www.pixalate.com/blog/publisher-request-reevaluation-mrt" target="_blank">Learn more</a>
</div>

<div class='text-center meta-link mt-3' *ngIf="currentConfig?.key === 'seller-childrens-privacy'">
  <h6>Read about the Child Audience Risk Metric</h6>
  <a class="btn btn-primary methodology-link text-light"
    href="https://www.pixalate.com/knowledgebase/childrens-privacy-index-sellers" target="_blank">Learn more</a>
</div>

<div class='text-center meta-link mt-3'>
  <h6>Read About Our COPPA Audience Assessment</h6>
  <a class="btn btn-primary methodology-link text-light"
    href="https://www.pixalate.com/coppa-compliance-tools-methodology" target="_blank">Click here</a>
</div>